import "core-js/modules/es.array.push.js";
import moment from "moment";
import { phoneDesc, isPhoneNumber, EncryptName, exportFile, getDayCounts } from "../../util/index";
import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { orderStatusList, invoiceSuccessList } from "@/util/type";
export default {
  name: "StatementAccount",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      amount: 0,
      invoiceAmount: 0,
      list: [],
      page: 1,
      //当前页数
      size: 10,
      //一页几条
      total: 0,
      //共几条
      pages: 0,
      //一共几页
      times: moment().format("YYYY-MM"),
      draweeName: "",
      drawerName: "",
      goodsName: "",
      invoiceSuccess: -1,
      month: 0,
      status: -1,
      year: new Date().getFullYear(),
      shortcuts: [{
        text: `${new Date().getFullYear()}年全部`,
        value: a => {
          data.month = 0;
          statementQuery();
        }
      }],
      years: [],
      months: ["全部", "1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
    });
    onMounted(() => {
      for (var i = new Date().getFullYear() - 10; i <= new Date().getFullYear(); i++) {
        data.years.unshift(i);
      }
      statementQuery();
    });
    //对账单查询
    const statementQuery = async () => {
      const params = {
        goodsName: data.goodsName,
        draweeName: data.draweeName,
        drawerName: data.drawerName,
        invoiceSuccess: data.invoiceSuccess,
        month: data.month,
        status: data.status,
        year: data.year,
        page: data.page,
        size: data.size
      };
      var res = await globalProperties.$api.statementQuery(params);
      if (res) {
        data.amount = res.amount;
        data.invoiceAmount = res.invoiceAmount;
        data.page = res.statementVOList.current;
        data.size = res.statementVOList.size;
        data.total = res.statementVOList.total;
        data.pages = res.statementVOList.pages;
        data.list = res.statementVOList.records;
      }
    };
    const currentChange = page => {
      data.page = page;
      statementQuery();
    };
    const reset = () => {
      data.page = 1;
      data.size = 10;
      data.draweeName = "";
      data.goodsName = "";
      data.drawerName = "";
      data.invoiceSuccess = -1;
      data.status = -1;
      data.times = moment().format("YYYY-MM");
      data.year = new Date().getFullYear();
      data.month = new Date().getMonth() + 1;
      statementQuery();
    };
    const exportForwarderStatement = async () => {
      const params = {
        draweeName: data.draweeName,
        drawerName: data.drawerName,
        goodsName: data.goodsName,
        invoiceSuccess: data.invoiceSuccess,
        month: data.month,
        page: data.page,
        size: data.size,
        status: data.status,
        year: data.year
      };
      exportFile(await globalProperties.$api.exportStatement(params), `${data.year}-${data.month}对账单`);
    };
    const panelChange = value => {
      data.year = new Date(value).getFullYear();
      data.shortcuts[0].text = data.year + "年全部";
    };
    const viewDetail = orderId => {
      router.push({
        path: "/layout/statementaccountdetail",
        query: {
          orderId
        }
      });
    };
    return {
      mainStore,
      data,
      zhCn,
      currentChange,
      invoiceSuccessList,
      phoneDesc,
      isPhoneNumber,
      EncryptName,
      viewDetail,
      moment,
      panelChange,
      statementQuery,
      exportForwarderStatement,
      orderStatusList,
      reset
    };
  }
};